export default {
	unitName: "ArticleViewInfo",
	open(){
		this.el.querySelector('.floating-article-info').classList.toggle('display-none')
	}
}